export default {
  name: "english-question",
  props: {
    question: Object,
    bgColors: Object,
    bool: Object,
    isIE : Boolean,
    examFlameHeight: Function,
    dragOver : Function,
    dragLeave : Function,
    drop: Function,
    getTextHtml: Function
    
  },
  data: function() {
    return {
      blankStylings: {
        border: '2px solid rgba(0,153,220,1)', 
        minWidth: '33.33%',
        height: '25px',
        paddingBottom : '2px',
				textAlign: 'center', 
        borderRadius: '3px', 
        marginTop : '3px',
				// margin: '0.7rem',
        marginRight: "0.25rem !important",
       // position : 'relative',
				//marginLeft: '0',
				// marginTop: '0',
				// display: 'inline-block',
				display: 'inline-block',
      },
      questionColor: "rgb(0, 84, 122) !important",
      circleStyle : {
        width: '15px',
        height : '15px',
        marginTop: '1.8px',
        marginLeft : 'auto',
        marginRight : 'auto',
        left : '0px',
        right : '0px',
        borderRadius: '50%',
        textAlign: 'center',
      //  position : 'absolute',
        fontSize: '10px',
        border:' 0.1em solid #666',
        //display : 'inline-block',
        boxSizing: 'initial'
      },
      imageStyle : {
        minWidth: '50%',
        minHeight : '2px',
        maxWidth : '60%',
        marginLeft : '5px'
      },
      hasImage : false
    };
  },
  mounted: function() {
    if(this.isIE){
      this.circleStyle.fontSize = '9px';
      this.circleStye.marginTop = '1px';
    }
  },
  methods: {
    formatHtml: function(text) {
      let _text = text.replace(/\n/g, " :br ");
      _text = _text.replace(/\t/g, " :tab ");
      return this.getTextHtml(_text);
    },
    getTextReturn: function(text, index) {

      if (text === ":blank") return;
      if (text !== ":br" && text !== ":tab") {
       let ext = text.split('.').pop();
        if(ext === 'png' || ext === 'jpg'){
          this.hasImage=true;
        }else {
          
          return text;
        }
      }
    },
    getBlankStylings: function(text) {
      if (text !== ":blank") return {};
      
      return this.blankStylings;
    },
  },
};
